/**
 * Formats a due date string into a human-readable format
 * @param dueDate - The due date string to format
 * @returns Formatted date string with relative indicators (Today, Tomorrow, Yesterday, etc.)
 */
export const formatDueDate = (dueDate: string): string => {
  try {
    const date = new Date(dueDate);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Reset time components for comparison
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);
    tomorrow.setHours(0, 0, 0, 0);
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    if (compareDate.getTime() === today.getTime()) {
      return 'Today';
    } else if (compareDate.getTime() === yesterday.getTime()) {
      return 'Yesterday';
    } else if (compareDate < today) {
      return `${date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' })} (Overdue)`;
    } else if (compareDate.getTime() === tomorrow.getTime()) {
      return 'Tomorrow';
    } else {
      return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
    }
  } catch (e) {
    return 'Today';
  }
};
